import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ShieldCheck } from "lucide-react";

export default function DefensePackets() {
  const [packets, setPackets] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.packets().then(setPackets).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader testid="packets-header" title="Reimbursement Readiness Evidence Packets"
        subtitle="A consolidated, time-stamped record of the evidence and requirements evaluated at order readiness. Not evidence of coverage." />
      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow><TableHead>Packet #</TableHead><TableHead>Order</TableHead><TableHead>Final Status</TableHead><TableHead>Generated</TableHead><TableHead>By</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {packets.length === 0 && <TableRow><TableCell colSpan={5} className="py-8 text-center text-sm text-slate-500">No evidence packets generated yet. Open an evaluated order and select “Generate Evidence Packet”.</TableCell></TableRow>}
            {packets.map((p) => (
              <TableRow key={p.id} className="cursor-pointer hover:bg-slate-50" data-testid={`packet-row-${p.id}`} onClick={() => nav(`/defense-packets/${p.id}`)}>
                <TableCell className="font-mono text-xs"><ShieldCheck className="mr-1 inline h-3.5 w-3.5 text-teal-600" />{p.packet_number}</TableCell>
                <TableCell className="font-mono text-xs">{p.order_number}</TableCell>
                <TableCell><StatusBadge status={p.final_status} size="sm" /></TableCell>
                <TableCell className="text-xs">{new Date(p.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-xs">{p.generated_by}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
